<template>
  <v-col cols="12">
    <div>
      <naj-box :title="locales.sectionTitle">
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.deedId"
              :value.sync="formModel.deedId"
              :disabled="isChecking || viewMode"
              :validates="validationDeedId"
              @input="deedIdChanged"
            ></naj-input>
          </v-col>

          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.deedDate"
              :value.sync="formModel.deedDate"
              :disabled="isChecking || !formModel.deedId || viewMode"
              validates="required"
              @change="deedDateChanged"
            ></naj-input>
          </v-col>
          <v-col
            v-if="!isRetrieved"
            cols="4"
            align-self="center"
            class="text-right"
          >
            <naj-button
              v-if="isCheckButtonVisible"
              square
              :loading="isChecking"
              :disabled="!formModel.deedId || !formModel.deedDate || isChecking || viewMode"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <div>
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.realEstateType"
            :value.sync="formModel.realEstateTypeName"
            :disabled="true"
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.cityName"
            :value.sync="formModel.cityName"
            :disabled="true"
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.ownerName"
            :value.sync="formModel.ownerName"
            :disabled="true"
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.deedSource"
            :value.sync="formModel.deedSource"
            :disabled="true"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.serialNo"
            :value.sync="formModel.serial"
            :disabled="true"
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.blockNumber"
            :value.sync="formModel.blockNumber"
            :disabled="true"
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.planNumber"
            :value.sync="formModel.planNumber"
            :disabled="true"
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.area"
            :value.sync="formModel.areaText"
            :disabled="true"
          ></naj-input>
        </v-col>
      </v-row>
    </div>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  inject: ['$validator'],
  name: 'OwnershipDeedInfo',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isRetrieved: false,
      isChecking: false,
    };
  },
  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.OwnershipDeedInfo;
    },
    isCheckButtonVisible() {
      return !this.isRetrieved || this.isChecking;
    },
    validationDeedId() {
      return {
        numeric: true,
        required: true,
        isVerified: this.formModel.isVerified,
        ...this.validates,
      };
    },
  },
  mounted() {
    if (this.$route.params.objectKey) {
      this.getRealEstateData();
    }
  },
  methods: {
    ...mapGlobalActions(['getRealEstateDeedInfo']),
    getRealEstateData() {
      if (this.formModel.deedId && this.formModel.deedDate) {
        this.getRealEstateDeedInfo({
          deedId: this.formModel.deedId,
          deedDate: this.formModel.deedDate,
        })
          .then((res) => {
            if (res.data) {
              const deedInfoResult = res.data;
              if (deedInfoResult) {
                this.$set(this.formModel, 'isVerified', true);
                const mappedData = {
                  objectKey: deedInfoResult.deedNo,
                  ownerName: this.getOwnerName(res.data),
                  deedSource: deedInfoResult.deedSource,
                  deedNo: deedInfoResult.deedNo,
                  realEstateTypeName: deedInfoResult.deedRealState.length > 0 ? deedInfoResult.deedRealState[0].realEstateTypeName : null,
                  cityName: deedInfoResult.deedRealState.length > 0 ? deedInfoResult.deedRealState[0].cityName : null,
                  serial: deedInfoResult.deedRealState.length > 0 ? deedInfoResult.deedRealState[0].serial : null,
                  blockNumber: deedInfoResult.deedRealState.length > 0 ? deedInfoResult.deedRealState[0].blockNumber : null,
                  planNumber: deedInfoResult.deedRealState.length > 0 ? deedInfoResult.deedRealState[0].planNumber : null,
                  areaText: deedInfoResult.deedRealState.length > 0 ? deedInfoResult.deedRealState[0].areaText : null,
                };
                Object.keys(mappedData)
                  .map((key) => {
                    this.$set(this.formModel, key, mappedData[key]);
                    return key;
                  });
                this.isRetrieved = true;
              } else {
                this.toaster.error(this.local.common.noData);
                this.isRetrieved = false;
                this.$set(this.formModel, 'isVerified', false);
              }
            }
          })
          .catch(() => {
            this.toaster.error(this.local.common.noData);
            this.clearFormData();
            this.$set(this.formModel, 'isVerified', false);
          })
          .finally(() => {
            this.isChecking = false;
          });

      }
    },
    check() {
      this.isChecking = true;
      this.resetFlags();
      this.getRealEstateData();
    },
    resetFlags() {
      this.isRetrieved = false;
    },
    deedDateChanged(value) {
      this.resetFlags();
      if (!value)
        this.$set(this.formModel, 'deedId', null);
      this.$set(this.formModel, 'isVerified', false);
      this.clearFormData();
    },
    deedIdChanged(value) {
      this.resetFlags();
      if (!value)
        this.$set(this.formModel, 'deedDate', null);
      this.$set(this.formModel, 'isVerified', false);
      this.clearFormData();
    },
    getOwnerName(apiData) {
      if (apiData.deedOwners && apiData.deedOwners.length > 0) {
        return apiData.deedOwners[0].ownerName;
      }
      return null;
    },
    clearFormData() {
      const mappedData = {
        objectKey: null,
        ownerName: null,
        source: null,
        deedNo: null,
        deedSource: null,
        realEstateTypeName: null,
        cityName: null,
        serial: null,
        blockNumber: null,
        planNumber: null,
        areaText: null,
      };
      Object.keys(mappedData)
        .map((key) => {
          this.$set(this.formModel, key, mappedData[key]);
          return key;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>